import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/_components/SectionViewAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_components/TrackedExternalLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/about/about.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/about/components/imgwithbadge.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/about/components/aboutText.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/_landing/sections/contact/components/contact-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/_landing/sections/lesson-options/components/scrollToPricingBtn.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/patreon/patreon.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/paid-objective/paid-objective.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/paid-objective/components/features.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/lesson-options/lessonOptions.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/mission/mission.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/_landing/sections/pricing/pricing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/_landing/sections/socials/components/socialButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/socials/socials.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/_old-components/button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_old-components/essay.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_old-components/headingpair.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/lesson-options/components/featureBox.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/scheduling/components/schedule-buttons.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/scheduling/scheduling.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/testimonials/components/testimonial-list.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/testimonials/components/testimonial-item.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/testimonials/testimonials.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/_old-components/old-footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_old-components/subtle-info.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/app/_landing/sections/contact/contact.module.css");
